import store from '@/store';

const hideBreadcrumbs = () => {
    store.dispatch(`preferences/setShowBreadcrumbs`, false);
};

export default hideBreadcrumbs;
